// @ts-nocheck
import Layout from "../../components/Layout"
import { Box, Stack } from "@mui/material"
import { useDocumento } from "../../hooks/documenti"
import { Routes, Route, useParams } from "react-router-dom"
import { Info, PlayCircleOutlineOutlined, Layers, StarSharp, UploadFile, Star, Videocam } from "@mui/icons-material"
import { PageTitle } from "../../components/PageTitle"
import { useTranslation } from "react-i18next"
import DocumentoDettaglio from "./DocumentoDettaglio"
import Supporti from "../Supporti"
import FilesDigitali from "../FilesDigitali"
import SupportoDettaglio from "../Supporto/SupportoDettaglio"

export default function Documento() {
  const { id } = useParams()
  const { t, i18n } = useTranslation()
  const { data: documento, refetch } = useDocumento(parseInt(id as string))
  const lang = i18n.language

  return (
    <Layout>
      <Stack
        sx={{
          height: "100%",
          overflow: "hidden",
        }}
      >
        <PageTitle
          padding
          border
          title={documento?.titolo_label || t("general.senza_titolo")}
          breadcrumbs={[
            {
              label: t("general.documenti"),
              iconType: Star,
              to: `/${lang}/documenti`,
            },
            {
              label:documento?.titolo_label || t("general.senza_titolo")
            },
          ]}
          tabs={[
            {
              label: t("general.dettaglio"),
              iconType: Info,
              to: `/${lang}/documenti/${id}`,
            },
            {
              label: t("general.supporti"),
              iconType: Layers,
              to: `/${lang}/documenti/${id}/supporti`,
              matchTo: `/${lang}/documenti/${id}/supporti/*`,
            },
            {
              label: t("general.files"),
              iconType: Videocam,
              to: `/${lang}/documenti/${id}/files`,
            },
          ]}
        />

        <Routes>
          <Route index element={<DocumentoDettaglio />}></Route>
          <Route path={`supporti/:supportoId`} element={<SupportoDettaglio/>}></Route>
          <Route path={`supporti`} element={<Supporti documentoId={id} />}></Route>
          <Route path={`files`} element={<FilesDigitali documentoId={id} />}></Route>
        </Routes>
      </Stack>
    </Layout>
  )
}
